var exports = {
  "kL": "AvatarStack.module__container___RExOb3",
  "my": "AvatarStack.module__avatar___RExOb3",
  "KI": "AvatarStack.module__avatarButton___RExOb3",
  "vn": "AvatarStack.module__avatarContent___RExOb3",
  "ML": "AvatarStack.module__avatarContextMenuWrap___RExOb3",
  "hm": "AvatarStack.module__withMask___RExOb3",
  "i1": "AvatarStack.module__remainingCount___RExOb3",
};

module.exports = exports;
